module.exports = __webpack_public_path__ + "static/logo4-c334e95ad9027536f6fef8915f20d987.svg";